import { Droplets, FlaskConical, SprayCan } from "lucide-react";
import { SlideHeader, Headline, InfoBoxGrid } from "../shared";

export function Slide05Today() {
  const BOXES = [
    { title: "1 oz", body: "Refillable reservoir, worn all day. No bottle to carry.", icon: Droplets },
    { title: "Lotion, gel, liquid", body: "One device handles the formats brands already sell.", icon: FlaskConical },
    { title: "Mist and fragrance", body: "Interchangeable valves extend what it can deliver.", icon: SprayCan },
  ];
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-today">
      <SlideHeader n="05" label="Available Today" />
      <Headline>
        The formulation, <span className="text-accent">on the wrist.</span>
      </Headline>
      <InfoBoxGrid testid="pitch-today-boxes" boxes={BOXES} />
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-5">
        Manufactured and sold today: the dispenser. In development: sensors and a companion app.
      </p>
    </div>
  );
}
